module.exports = __webpack_public_path__ + "static/wavesAndBubbles-269cbde128268e0abe28a4c6fca44130.png";